<script>
export default {
	props: ['order', 'checkout'],
}
</script>

<template>
	<MercadoPagoCardContent />
</template>
